import { applyFormat } from "components/ui/ui-helpers";

const DetailCotisationsMsa = (props) => {
  const { DetailCotisations, DetailCSG, TotalChargesSociales } = props;

  // Fonction pour gérer les icônes spécifiques à la MSA
  const getIconStyle = (type) => {
    const iconMap = {
      amexa: {
        icon: "🏥",
        background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      },
      famille: {
        icon: "👨‍👩‍👧‍👦",
        background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      },
      ij: {
        icon: "🏥",
        background: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
      },
      invalidite: {
        icon: "🦽",
        background: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
      },
      retraite: {
        icon: "☀️",
        background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
      },
      "retraite-comp": {
        icon: "🌴",
        background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      },
      formation: {
        icon: "🎓",
        background: "linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)",
      },
      csg: {
        icon: "💰",
        background: "linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)",
      },
      "sous-total": {
        icon: "📊",
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      },
      total: {
        icon: "💰",
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      },
    };

    return iconMap[type] || { icon: "💼", background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)" };
  };

  return (
    <>
      <div className="cotisations-container">
        <div className="cotisations-list-container">
          <div className="cotisations-header">
            <div className="header-column"></div>
            <div className="header-column">Assiette</div>
            <div className="header-column">Taux</div>
            <div className="header-column">Montant dû</div>
          </div>
          <div className="cotisations-card light-title">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("sous-total").background,
                color: "#4f46e5",
              }}
            >
              {getIconStyle("sous-total").icon}
            </div>
            <div className="card-column">Cotisations {props.Prenom}</div>
            <div className="card-column"></div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("amexa").background,
              }}
            >
              {getIconStyle("amexa").icon}
            </div>
            <div className="card-column">AMEXA tranche 1</div>
            <div className="card-column">{DetailCotisations?.assiette_assurance_maladie}</div>
            <div className="card-column">{DetailCotisations?.taux_assurance_maladie}</div>
            <div className="card-column">{DetailCotisations?.amexa}</div>
          </div>
          {DetailCotisations?.amexa2 !== "0 €" && (
            <div className="cotisations-card">
              <div
                className="cotisations-card-icon"
                style={{
                  background: getIconStyle("amexa").background,
                }}
              >
                {getIconStyle("amexa").icon}
              </div>
              <div className="card-column">AMEXA tranche 2</div>
              <div className="card-column">{DetailCotisations?.assiette_assurance_maladie2}</div>
              <div className="card-column">{DetailCotisations?.taux_assurance_maladieT2}</div>
              <div className="card-column">{DetailCotisations?.amexa2}</div>
            </div>
          )}
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("famille").background,
              }}
            >
              {getIconStyle("famille").icon}
            </div>
            <div className="card-column">Allocations familiales</div>
            <div className="card-column">{DetailCotisations?.assiette}</div>
            <div className="card-column">{DetailCotisations?.taux_allocation_familiale}</div>
            <div className="card-column">{DetailCotisations?.allocation_familiale}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("ij").background,
              }}
            >
              {getIconStyle("ij").icon}
            </div>
            <div className="card-column">Indemnités journalières AMEXA</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.ij_amexa}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("invalidite").background,
              }}
            >
              {getIconStyle("invalidite").icon}
            </div>
            <div className="card-column">Invalidité décès ATEXA</div>
            <div className="card-column">-</div>
            <div className="card-column">-</div>
            <div className="card-column">{DetailCotisations?.atexa}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("retraite").background,
              }}
            >
              {getIconStyle("retraite").icon}
            </div>
            <div className="card-column">Retraite de base plafonnée</div>
            <div className="card-column">{DetailCotisations?.assiette_ava_plafonnee}</div>
            <div className="card-column">{DetailCotisations?.taux_ava_plafonne}</div>
            <div className="card-column">{DetailCotisations?.ava_plafonne}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("retraite").background,
              }}
            >
              {getIconStyle("retraite").icon}
            </div>
            <div className="card-column">Retraite de base déplafonnée</div>
            <div className="card-column">{DetailCotisations?.assiette_ava_deplafonnee}</div>
            <div className="card-column">{DetailCotisations?.taux_ava_deplafonne}</div>
            <div className="card-column">{DetailCotisations?.ava_deplafonne}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("retraite-comp").background,
              }}
            >
              {getIconStyle("retraite-comp").icon}
            </div>
            <div className="card-column">Retraite complémentaire</div>
            <div className="card-column">{DetailCotisations?.assiette_retraite_complementaire}</div>
            <div className="card-column">{DetailCotisations?.taux_retraite_complementaire}</div>
            <div className="card-column">{DetailCotisations?.retraite_complementaire}</div>
          </div>
          <div className="cotisations-card light-title">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("sous-total").background,
                color: "#4f46e5",
              }}
            >
              {getIconStyle("sous-total").icon}
            </div>
            <div className="card-column" style={{ gridColumn: "2 / 4" }}>
              Cotisations sociales obligatoires <span style={{ fontSize: "12px" }}>&nbsp;(hors formation et CSG-CRDS)</span>
            </div>
            <div className="card-column">{applyFormat(DetailCSG?.ChargesSocialesObligatoire, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("formation").background,
              }}
            >
              {getIconStyle("formation").icon}
            </div>
            <div className="card-column">Formation professionnelle</div>
            <div className="card-column">{DetailCotisations?.assiette_formation_professionnelle}</div>
            <div className="card-column">{DetailCotisations?.taux_formation_professionnelle}</div>
            <div className="card-column">{DetailCotisations?.formation_professionnelle}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("csg").background,
              }}
            >
              {getIconStyle("csg").icon}
            </div>
            <div className="card-column">CSG déductible</div>
            <div className="card-column">{applyFormat(DetailCSG?.assiette_csg, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.TauxCSGDeductible, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          <div className="cotisations-card">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("csg").background,
              }}
            >
              {getIconStyle("csg").icon}
            </div>
            <div className="card-column">CSG non déductible + CRDS</div>
            <div className="card-column">{applyFormat(DetailCSG?.assiette_csg, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.TauxCSGNonDeductible, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
            <div className="card-column">{applyFormat(DetailCSG?.csg_non_deductible, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          {Number(DetailCSG?.csg_primes) > 0 && (
            <div className="cotisations-card">
              <div
                className="cotisations-card-icon"
                style={{
                  background: getIconStyle("csg").background,
                }}
              >
                {getIconStyle("csg").icon}
              </div>
              <div className="card-column">CSG non déductible + CRDS sur épargne salariale</div>
              <div className="card-column">{applyFormat(DetailCSG?.assiette_csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
              <div className="card-column">{applyFormat(DetailCSG?.TauxCSG, "ufloat", { thousands: " ", decimal: ",", precision: 2, unit: "%" })}</div>
              <div className="card-column">{applyFormat(DetailCSG?.csg_primes, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          )}
          <div className="cotisations-card light-title">
            <div
              className="cotisations-card-icon"
              style={{
                background: getIconStyle("total").background,
                color: "#22c55e",
              }}
            >
              {getIconStyle("total").icon}
            </div>
            <div className="card-column" style={{ gridColumn: "2 / 4" }}>
              Total des cotisations sociales
            </div>
            <div className="card-column">{applyFormat(TotalChargesSociales, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailCotisationsMsa;
